module.exports = __webpack_public_path__ + "img/appstore.57272347.svg";